import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import centerService from "services/center-service";
import { Card, Grid } from "@mui/material";
import CenterForm from "./form";
import { UpdateButton } from "layouts/common/buttons";

const EditCenter = () => {
  const { id } = useParams(); // Retrieve id from URL
  const [center, setcenter] = useState(null);
  const [loading, setLoading] = useState(false);
  const formRef = useRef(); // Reference to the form

  const getCenterData = async () => {
    const centerData = await centerService.get(id);
    if (centerData.success === true && centerData.center) {
      setcenter(centerData.center);
      console.log("centerData", centerData.center);
    }
  };

  useEffect(() => {
    getCenterData();
  }, [id]);

  const handleSave = () => {
    if (formRef.current) {
      formRef.current.submitHandler();
    }
  };

  return (
    center && (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h6" color="white">
                    Edit Center
                  </MDTypography>
                  <UpdateButton loading={loading} onClick={handleSave} />
                </MDBox>
                <CenterForm ref={formRef} initialData={{ ...center.user, ...center }}
                  type="edit" />
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    )
  );
};

export default EditCenter;
